module["exports"] = [
  "###-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/address/postcode.js
// module id = 1411
// module chunks = 0